export default __webpack_public_path__ + "locales/vi/Errors.json?hash=8baa607671c2fe0705ab425d30ccdf7a";